import { render } from "./TradeDetails.vue?vue&type=template&id=4a6ad522&scoped=true&ts=true"
import script from "./TradeDetails.vue?vue&type=script&lang=ts"
export * from "./TradeDetails.vue?vue&type=script&lang=ts"

import "./TradeDetails.vue?vue&type=style&index=0&id=4a6ad522&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6ad522"]])

export default __exports__